import type { LifecyclePort } from '../types';

/** visibilitychange + pagehide/pageshow + freeze/resume (plan §5.4: never rely on beforeunload alone). */
export function createWebLifecycle(doc: Document = document, win: Window = window): LifecyclePort {
  return {
    isHidden: () => doc.visibilityState === 'hidden',
    onPause(cb) {
      const onVisibility = () => {
        if (doc.visibilityState === 'hidden') cb();
      };
      doc.addEventListener('visibilitychange', onVisibility);
      win.addEventListener('pagehide', cb);
      doc.addEventListener('freeze', cb);
      return () => {
        doc.removeEventListener('visibilitychange', onVisibility);
        win.removeEventListener('pagehide', cb);
        doc.removeEventListener('freeze', cb);
      };
    },
    onResume(cb) {
      const onVisibility = () => {
        if (doc.visibilityState === 'visible') cb();
      };
      doc.addEventListener('visibilitychange', onVisibility);
      win.addEventListener('pageshow', cb);
      doc.addEventListener('resume', cb);
      return () => {
        doc.removeEventListener('visibilitychange', onVisibility);
        win.removeEventListener('pageshow', cb);
        doc.removeEventListener('resume', cb);
      };
    },
  };
}
